<template>
	<div class="row">
		<div class="col-md-12">
			<div class="form-group">
				<label>Resource Type</label>
				<multiselect
					name="link_type"
					:options="optionsForLinkType.map(x => x.id)"
					label="name"
					v-model="linkType.value"
					:allow-empty="false"
				>
					<template slot="singleLabel" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span class="link-type-title">{{ getOptionObject(props.option).name }}</span>
					</template>
					<template slot="option" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span class="link-type-title">{{ getOptionObject(props.option).name }}</span>
					</template>
				</multiselect>
			</div>
		</div>
		<div class="col-md-12" v-show="error">
			<div class="alert alert-danger">URL is required</div>
		</div>
		<div class="col-md-12" v-show="!isFile">
			<div class="form-group">
				<label>URL <i class="far fa-copy"></i></label>
				<div class="input-group">
					<input required type="text" v-model="linkUrl.value" class="form-control"  v-on:keyup.enter="saveFn" ref="focusThis"/>
					<div class="input-group-append">
						<button @click="copyUrl" id="copy-url-btn" class="btn btn-text btn-copy" type="button" data-dismiss="modal"><i :class="copyIcon"></i></button>
						<b-tooltip target="copy-url-btn" triggers="hover" noninteractive>{{copyTooltipText}}</b-tooltip>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12" v-show="!isFile">
			<div class="form-group">
				<label>Label</label>
				<input type="text" v-model="linkLabel.value" class="form-control"  v-on:keyup.enter="saveFn"/>
			</div>
		</div>
		<div class="col-md-12" v-show="!isFile">
			<div class="form-group">
				<label>Notes</label>
				<textarea class="form-control" v-model="linkNotes.value"></textarea>
			</div>
		</div>

		<div class="row col-md-12" v-show="!isFile">
		<div class="col">
			<button class="btn btn-primary" type="button" @click="saveFn" data-dismiss="modal">Save</button>
		</div>
		</div>
		<AddResourceFileModal v-show="isFile" ref="refResourceFileModal" 
		:link-url="linkUrl" :link-label="linkLabel" :link-notes="linkNotes" :link-type="linkType" 
		:resource-parent="resourceParent" :namespace="namespace" />
	</div>
</template>

<script>
import { mapState } from "vuex";
import AddResourceFileModal from "./AddResourceFileModal";

export default {
	props: {
		linkUrl:Object,
		linkLabel:Object,
		linkNotes:Object,
		linkType:Object,
		resourceParent: String,
		namespace:String,
	},
	components: {
		AddResourceFileModal,
	},
	data() {
		return {
			filteredStates: [],
			error: false,
			isFile: false,
			copySuccessTimeout: null,
			copyIcon: 'far fa-copy',
			copyTooltipText: 'Copy URL',
		};
	},
	computed: {
		...mapState({
		  state (state) {
		    return state[this.namespace]
		  },
		  deliverableDetail (state, getters) {
		    return getters[this.namespace + 'deliverableDetail']
		  },
		  deliverableContactsLabel (state, getters) {
		    return getters[this.namespace + 'deliverableContactsLabel']
		  },
		  deliverableContactCompanyLabel (state, getters) {
		    return getters[this.namespace + 'deliverableContactCompanyLabel']
		  },
		  allCustomFields (state, getters) {
		    return getters[this.namespace + 'allCustomFields']
		  },
		}),
		optionsForLinkType() {
			const linkTypeField = this.allCustomFields.find(x => x.id == 37);
			return JSON.parse(linkTypeField.value_set);
		},
	},
	methods: {
		focusMyElement() {
			if (this.$refs.focusThis) {
				this.$refs.focusThis.focus();
			}
		},
		saveFn() {
			let that = this;
			if(!that.linkUrl.value) {
				that.error = true
			} else {
				this.$store
				.dispatch(this.namespace + "createDeliverableLinkUrl", {linkUrl:this.linkUrl,linkLabel:this.linkLabel,linkNotes:this.linkNotes,linkType:this.linkType})
				.then(() => {
					that.$bvModal.hide('createLinkModal')
				});
			}

		},
			removeFn() {
				this.$bvModal.hide('createLinkModal')
			},
		getOptionObject(id) {
			return this.optionsForLinkType.find(x => x.id == id);
		},

		async copyUrl() {
			clearTimeout(this.copySuccessTimeout);
			try {
				const navPer = await navigator.permissions.query({name: "clipboard-write"});
				if (navPer.state == "granted" || navPer.state == "prompt") {
					try {
						await navigator.clipboard.writeText(this.linkUrl.value);
					} catch {
						console.error("clipboard API error. Cannot copy to clipboard.");
						this.legacyCopyMethod();
					}
				} else {
					this.legacyCopyMethod();
				}
			} catch {
					try {
						await navigator.clipboard.writeText(this.linkUrl.value);
					} catch {
						console.error("clipboard API error. Cannot copy to clipboard.");
						this.legacyCopyMethod();
					}

			}

			this.copyIcon = "fas fa-check";
			this.copyTooltipText = "Copied!";
			this.copySuccessTimeout = setTimeout(() => {
				this.copyIcon = "far fa-copy";
				this.copyTooltipText = "Copy URL";
			}, 2000);
		},
		legacyCopyMethod() {
			this.$refs.focusThis.select();
			document.execCommand("copy");
			this.$refs.focusThis.blur();
		},
	},
	watch: {
		linkType: {
			handler(newVal) {
				this.filteredOption = this.optionsForLinkType.find(option => option.id === newVal.value);
				if (this.filteredOption.slug == "file") {
					this.isFile = true;
				} else {
					this.isFile = false;
				}
			},
			deep: true,
			immediate: true,
		}
	},
};
</script>

<style>
</style>